import APIService from '../api';

const CURRENT_COUNTRY_STORAGE = '@twism:current-country';

export default class InternationalizationService extends APIService {
  getCountries(data?: { params: Record<string, string> }) {
    return this.get('/location/country', data || {});
  }

  async getCurrentCountry(data?: { params: Record<string, string> }) {
    const storageCurrentCountry = localStorage.getItem(CURRENT_COUNTRY_STORAGE);
    if (storageCurrentCountry)
      return { data: JSON.parse(storageCurrentCountry) };

    const response = await this.get('/v2/location/current-country', data || {});
    if (response) {
      localStorage.setItem(
        CURRENT_COUNTRY_STORAGE,
        JSON.stringify(response.data)
      );
    }
    return response;
  }

  reportNewIntegration(data: any) {
    return this.post('/report', data);
  }

  reportNewIntegrationWithoutUser(data: any) {
    return this.post('/report/without-user', data);
  }

  // Filters by ISO code, not by name: `GET /location/country` translates the
  // country name with the `x-lang` header, and no translated name matches.
  getCountryIntegrations(countryIso2: string) {
    return this.get('/integration', {
      params: {
        filters: `country.iso2:${countryIso2}`,
        limit: 1000
      }
    });
  }
}
